/**
 * Class for latitude and longitude coordinates
 */
export class LatLng {
    /**
     * @param lat {number}
     * @param lng {number}
     */
    constructor(lat, lng) {
        this.lat = lat;
        this.lng = lng;
    }
}
